<picture>
	@for (source of resolvedSources; track $index) {
		<source
			[media]="source.media"
			[srcset]="
				img().src
					| imageQuery: { height: source.height, width: source.width }
			"
			type="image/webp"
		/>
	}
	<img
		[attr.alt]="img().altText || null"
		[attr.role]="!img().altText ? 'presentation' : null"
		[attr.style]="img().style"
		[attr.width]="imageWidth() ? imageWidth() : null"
		[class]="
			cn(
				!showFallbackImage() && 'object-cover',
				showFallbackImage() && 'mx-auto bg-ui-25 object-none',
				'w-full',
				className()
			)
		"
		[src]="
			img().src | imageQuery: { height: img().height, width: img().width }
		"
		(error)="setFallbackImage()"
	/>
</picture>
